import { Modal } from 'bootstrap';

function initializeWorkerHourlyRates() {
  const section = document.getElementById('worker-hourly-rates');
  if (!section || section.dataset.initialized) return;
  section.dataset.initialized = 'true';
  const inputs = section.querySelector('[data-rate-inputs]');
  const historyElement = document.getElementById('worker-rate-history-modal');
  const editElement = document.getElementById('worker-rate-edit-modal');
  const historyModal = new Modal(historyElement);
  const editModal = new Modal(editElement);
  const editForm = document.getElementById('worker-rate-edit-form');
  const rateInput = document.getElementById('worker-rate-value');
  const monthInput = document.getElementById('worker-rate-month');
  const memoInput = document.getElementById('worker-rate-memo');
  const errors = editElement.querySelector('[data-rate-errors]');
  const workerForm = section.closest('form');
  let editingRow = null;
  let returnToHistory = false;
  let dirty = false;
  let submitting = false;
  let nextKey = inputs.children.length;
  const field = (row, name) => row.querySelector(`[data-rate-field="${name}"]`);
  const activeRows = () => Array.from(inputs.children).filter(row => field(row, '_destroy').value !== '1');
  const currentRow = () => activeRows().filter(row => field(row, 'application_start_month').value &&
    Number.isInteger(Number(field(row, 'hourly_rate').value)) && Number(field(row, 'hourly_rate').value) > 0 && Number(field(row, 'hourly_rate').value) <= 9999999 &&
    field(row, 'application_start_month').value <= section.dataset.currentMonth)
    .sort((a, b) => field(b, 'application_start_month').value.localeCompare(field(a, 'application_start_month').value))[0];
  const displayRate = row => {
    const value = field(row, 'hourly_rate').value;
    return `${Number.isFinite(Number(value)) ? Number(value).toLocaleString('ja-JP') : value} 円／時間`;
  };
  const displayMonth = row => field(row, 'application_start_month').value.replace('-', '/');
  const pickerMonth = month => month.replace('-', '/');
  const storedMonth = month => month.replace('/', '-');
  const normalizeRate = value => value.replace(/[０-９]/g, digit => String.fromCharCode(digit.charCodeAt(0) - 0xFEE0)).replace(/,/g, '').trim();

  function refresh() {
    const current = currentRow();
    section.querySelector('[data-rate-current]').textContent = current ? displayRate(current) : '未設定';
    section.querySelector('[data-rate-start]').textContent = current ? `（適用開始：${displayMonth(current)}）` : '';
    const body = historyElement.querySelector('[data-rate-history-body]');
    body.replaceChildren();
    const rows = activeRows().sort((a, b) => field(b, 'application_start_month').value.localeCompare(field(a, 'application_start_month').value));
    if (!rows.length) {
      const cell = body.insertRow().insertCell();
      cell.colSpan = 4;
      cell.textContent = '単価履歴がありません。';
    }
    rows.forEach(row => {
      const tr = body.insertRow();
      const month = tr.insertCell();
      month.textContent = displayMonth(row);
      if (row === current) {
        const marker = document.createElement('span');
        marker.className = 'worker-rate-current-marker';
        marker.textContent = '適用中';
        month.append(marker);
      }
      tr.insertCell().textContent = displayRate(row);
      const memo = tr.insertCell();
      memo.textContent = field(row, 'memo').value;
      const actions = tr.insertCell();
      actions.className = 'worker-rate-row-actions';
      [['edit', '編集', 'fa-pencil'], ['delete', '削除', 'fa-trash']].forEach(([action, label, icon]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'btn btn-sm btn-outline-secondary worker-rate-icon-button';
        button.title = label;
        button.setAttribute('aria-label', label);
        const symbol = document.createElement('i');
        symbol.className = `fa ${icon}`;
        symbol.setAttribute('aria-hidden', 'true');
        button.append(symbol);
        button.addEventListener('click', () => {
          if (action === 'edit') openEditor(row, true);
          else if (window.confirm('この単価履歴を削除しますか？')) {
            if (field(row, 'id').value) field(row, '_destroy').value = '1';
            else row.remove();
            dirty = true;
            refresh();
          }
        });
        actions.append(button);
      });
    });
  }

  function openEditor(row, fromHistory) {
    editingRow = row;
    returnToHistory = fromHistory;
    editElement.querySelector('.modal-title').textContent = row ? '工数単価 編集' : '工数単価 変更';
    errors.classList.add('d-none');
    rateInput.value = row ? Number(field(row, 'hourly_rate').value).toLocaleString('ja-JP') : '';
    const defaultMonth = new Date(`${section.dataset.currentMonth}-01T00:00:00Z`);
    if (currentRow()) defaultMonth.setUTCMonth(defaultMonth.getUTCMonth() + 1);
    monthInput.value = pickerMonth(row ? field(row, 'application_start_month').value : defaultMonth.toISOString().slice(0, 7));
    const monthPicker = window.$(monthInput).data('daterangepicker');
    if (monthPicker) monthPicker.setStartDate(monthInput.value);
    memoInput.value = row ? field(row, 'memo').value : '';
    const current = currentRow();
    editElement.querySelector('[data-rate-reference]').textContent = current ? `${displayRate(current)}（適用開始：${displayMonth(current)}）` : '未設定';
    if (fromHistory) {
      historyElement.addEventListener('hidden.bs.modal', () => editModal.show(), { once: true });
      historyModal.hide();
    } else editModal.show();
  }

  section.querySelector('[data-rate-add]').addEventListener('click', () => openEditor(null, false));
  historyElement.querySelector('[data-rate-add]').addEventListener('click', () => openEditor(null, true));
  section.querySelector('[data-rate-history]').addEventListener('click', () => historyModal.show());
  editElement.addEventListener('hidden.bs.modal', () => { if (returnToHistory) historyModal.show(); });
  editElement.addEventListener('shown.bs.modal', () => rateInput.focus());
  rateInput.addEventListener('blur', () => {
    const value = normalizeRate(rateInput.value);
    if (/^\d{1,7}$/.test(value)) rateInput.value = Number(value).toLocaleString('ja-JP');
  });
  editForm.addEventListener('submit', event => {
    event.preventDefault();
    const rate = normalizeRate(rateInput.value);
    const month = storedMonth(monthInput.value);
    const messages = [];
    if (!/^\d{1,7}$/.test(rate) || Number(rate) < 1) messages.push('新しい工数単価は1〜9,999,999の整数で入力してください。');
    if (!/^(?!0000)\d{4}-(0[1-9]|1[0-2])$/.test(month)) messages.push('適用開始年月を入力してください。');
    if (activeRows().some(row => row !== editingRow && field(row, 'application_start_month').value === month)) messages.push('適用開始年月は既に登録されています。');
    if (editingRow && Array.from(inputs.children).some(row => row !== editingRow && field(row, 'id').value && field(row, '_destroy').value === '1' && field(row, 'application_start_month').value === month)) messages.push('この年月の削除を登録してから変更してください。');
    if (Array.from(memoInput.value).length > 100) messages.push('備考は100文字以内で入力してください。');
    errors.replaceChildren();
    messages.forEach(message => { const line = document.createElement('div'); line.textContent = message; errors.append(line); });
    errors.classList.toggle('d-none', !messages.length);
    if (messages.length) return;
    if (!editingRow) editingRow = Array.from(inputs.children).find(row => field(row, '_destroy').value === '1' && field(row, 'application_start_month').value === month);
    if (!editingRow) {
      editingRow = document.createElement('div');
      const key = nextKey++;
      ['id', 'application_start_month', 'hourly_rate', 'memo', '_destroy'].forEach(name => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `worker[worker_hourly_rate_histories_attributes][${key}][${name}]`;
        input.dataset.rateField = name;
        editingRow.append(input);
      });
      inputs.append(editingRow);
    }
    field(editingRow, 'application_start_month').value = month;
    field(editingRow, 'hourly_rate').value = rate;
    field(editingRow, 'memo').value = memoInput.value;
    field(editingRow, '_destroy').value = '0';
    dirty = true;
    refresh();
    editModal.hide();
  });
  workerForm.addEventListener('change', () => { dirty = true; });
  workerForm.addEventListener('input', () => { dirty = true; });
  workerForm.addEventListener('submit', () => { submitting = true; });
  workerForm.querySelector('.btn-cancel').closest('a').addEventListener('click', event => {
    if (dirty && !window.confirm('変更内容が保存されていません。戻りますか？')) event.preventDefault();
    else submitting = true;
  });
  window.addEventListener('beforeunload', event => {
    if (dirty && !submitting) { event.preventDefault(); event.returnValue = ''; }
  });
  refresh();
}

document.addEventListener('DOMContentLoaded', initializeWorkerHourlyRates);
document.addEventListener('turbolinks:load', initializeWorkerHourlyRates);
